import React, { useState } from "react";
import {
  PrimaryButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import Dropdown from "../dropdown/Dropdown";
import Badge from "../badge/Badge";

export default function InputTableRow({
  onCancel,
  onSave,
  optionData,
  hasRows,
  module = "student",
  draggable = false,
  colSpan,
}) {
  const initialState = {
    selectedItem: "",
  };

  const [inputData, setInputData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSave = () => {
    const selectedItem = optionData.find(
      (item) => item.id === inputData.selectedItem
    );
    if (selectedItem) {
      onSave(selectedItem);
    }
    setInputData(initialState);
  };

  const handleCancel = () => {
    onCancel();
    setInputData(initialState);
  };

  const dropdownOptions = optionData.map((item) => {
    if (module === "associatedStudent") {
      const stopNames = item.stopData?.map((s) => s.stopName).join(", ") || "";

      return {
        label: `${item.name}${item.class ? ` (${item.class})` : ""}${
          stopNames ? ` - ${stopNames}` : ""
        }`,
        value: item.id,
      };
    }

    if (module === "stopsArray") {
      return { label: item.name, value: item.id };
    }

    return { label: item.name, value: item.id};
  });

  const isSaveDisabled = !inputData.selectedItem;

  return (
    <tr>
      <td colSpan={colSpan ?? (draggable || hasRows ? 6 : 4)}>
        <div
          className="input-table-row"
          style={{
            display: "flex",
            gap: "1rem",
            padding: "0rem 0rem",
            width: "100%",
          }}
        >
          <div className="input-table-dropdown">
            <Dropdown
              options={dropdownOptions}
              name="selectedItem"
              input={inputData}
              onChangeFunction={handleChange}
              placeholder={
                module === "associatedStudent"
                  ? "Select Student"
                  : "Select Stop"
              }
              width="100%"
            />
          </div>
          <div
            className="input-table-buttons"
            style={{ display: "flex", gap: "0.5rem" }}
          >
            <SecondaryButton
              width="5rem"
              label="Cancel"
              imageIcon={false}
              onClickFunction={handleCancel}
            />
            <PrimaryButton
              width="5rem"
              label="Save"
              onClickFunction={handleSave}
              disable={isSaveDisabled}
            />
          </div>
        </div>
      </td>
    </tr>
  );
}
